function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Profile",
  "data-name": "Profile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Noteable-/-Tasting-Tool-/-Desktop-/-Oak-Copy-5",
  "data-name": "Noteable-/-Tasting-Tool-/-Desktop-/-Oak-Copy-5",
  transform: "translate(-746.000000, -509.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Profile_Group_1",
  "data-name": "Profile_Group_1",
  fill: "#F5F4EF",
  x: 0,
  y: 0,
  width: 1440,
  height: 900
}), /*#__PURE__*/React.createElement("g", {
  id: "radio-button-selected",
  "data-name": "radio-button-selected",
  transform: "translate(746.000000, 509.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  "data-name": "Oval",
  stroke: "#391D4D",
  strokeWidth: 2,
  cx: 8,
  cy: 8,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  "data-name": "Oval",
  fill: "#391D4D",
  fillRule: "evenodd",
  cx: 8,
  cy: 8,
  r: 3
}))));

var SvgIconSelectedRadio = function SvgIconSelectedRadio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSelectedRadio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-selected-radio.151cb02e.svg";
export { ForwardRef as ReactComponent };